// extracted by mini-css-extract-plugin
export var sidebarSection = "styles-module--sidebarSection--G2lxo";
export var chapterTitleContainer = "styles-module--chapterTitleContainer--ZkN0R";
export var chapterTitle = "styles-module--chapterTitle--JnM8+";
export var activeTitle = "styles-module--activeTitle--G9Q9v";
export var title = "styles-module--title--OEpoU";
export var backAndForthRight = "styles-module--backAndForthRight--eZ8pZ";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--FEyE4";
export var animateBg = "styles-module--animateBg--2ZWoa";